export const formatCurrency = (number: number | null | undefined) => {
  return number || number === 0
    ? number.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      })
    : "";
};
